
import React, { useState } from 'react';
import { EmergencyReportsList } from '@/components/emergency-reports/EmergencyReportsList';
import { ReportsFilters } from '@/components/reports/ReportsFilters';

interface EmergencyReportsViewProps {
  teamId: string;
}

export const EmergencyReportsView = ({ teamId }: EmergencyReportsViewProps) => {
  const [selectedTeam, setSelectedTeam] = useState<string | undefined>(teamId);
  const [selectedDate, setSelectedDate] = useState<Date | undefined>();

  const handleReset = () => {
    setSelectedTeam(teamId);
    setSelectedDate(undefined);
  };

  const dateFilter = selectedDate ? {
    start: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0),
    end: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 23, 59, 59)
  } : undefined;

  return (
    <div className="p-6 space-y-6">
      <ReportsFilters
        selectedTeam={selectedTeam}
        onTeamChange={setSelectedTeam}
        selectedDate={selectedDate}
        onDateChange={setSelectedDate}
        onReset={handleReset}
        showTeamFilter={false} // Hide team filter since we're already in a team context
      />
      
      <EmergencyReportsList 
        teamId={selectedTeam || teamId} 
        dateFilter={dateFilter}
      />
    </div>
  );
};
